import * as React from 'react';
import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    BodyText1,
    InternalLink,
    Modal,
    ModalBody,
    ModalButton,
    ModalFooter,
    ModalHeader,
} from '@portal/common/components';
import { styled } from '@portal/common/theme';
import { WithRouterProps, withRouter } from '@portal/common/utility/hoc/with-router';

import _ from '../../../locale';
import { DATA_EXPLORER_PATH } from '../../../router/paths';
import { getOrganizationId } from '../../../store/organization/selectors';
import { setNotificationShown, updateAccount } from '../../../store/session/actions';
import { getSessionAccountId } from '../../../store/session/selectors';

const StyledModal = styled(Modal)({
    marginTop: 150,
});

const StyledHeader = styled(ModalHeader)({
    marginTop: 10,
    display: 'flex',
    flexDirection: 'row-reverse',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingRight: 20,
    paddingLeft: 20,
});

const BodyText1Styled = styled(BodyText1)(({ theme }) => ({
    marginTop: 20,
    textAlign: 'center',
    fontWeight: theme.typography.fontWeight.base,
}));

const ModalBodyStyled = styled(ModalBody)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'column',
});

type Props = WithRouterProps & {};

const NewGBDBecomesDefaultPopup: React.FC<Props> = memo(({ history }) => {
    const dispatch = useDispatch();

    const accountId = useSelector(getSessionAccountId);
    const organizationId = useSelector(getOrganizationId);

    const handleClose = useCallback(() => {
        if (organizationId && accountId) {
            dispatch(setNotificationShown(true));
            dispatch(updateAccount(organizationId, accountId, { is_notification_shown: true }));
        }
    }, [organizationId, accountId, dispatch]);

    const handleExploreClick = useCallback(() => {
        handleClose();
        history.push(DATA_EXPLORER_PATH);
    }, [handleClose, history]);

    const LinkToDEX = (props) => (
        <InternalLink {...props} to={DATA_EXPLORER_PATH} onClick={handleClose} />
    );

    return (
        <StyledModal show onHide={handleClose}>
            <StyledHeader closeButton>
                {_('notification_new_gbd_becomes_default_title')}
            </StyledHeader>
            <ModalBodyStyled>
                <BodyText1Styled>
                    {_('notification_new_gbd_becomes_default_message')(LinkToDEX)}
                </BodyText1Styled>
            </ModalBodyStyled>
            <ModalFooter>
                <ModalButton type="submit" onClick={handleExploreClick}>
                    {_('explore_now_button')}
                </ModalButton>
            </ModalFooter>
        </StyledModal>
    );
});

export default withRouter(NewGBDBecomesDefaultPopup);
